import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const deviceManufacturerConstants = {
    DEVICE_MANUFACTURER_LOADED: 'DEVICE_MANUFACTURER_LOADED',
    DEVICE_MANUFACTURER_CREATED: 'DEVICE_MANUFACTURER_CREATED',
    DEVICE_MANUFACTURER_UPDATED: 'DEVICE_MANUFACTURER_UPDATED',
    DEVICE_MANUFACTURER_DELETED: 'DEVICE_MANUFACTURER_DELETED'
};

export const deviceManufacturerFulfilledConstants = getActionTypesResult(deviceManufacturerConstants, '_FULFILLED');

export const deviceManufacturerRejectedConstants = getActionTypesResult(deviceManufacturerConstants, '_REJECTED');

export const deviceManufacturerPendingConstants = getActionTypesResult(deviceManufacturerConstants, '_PENDING');

export const fetchDeviceManufacturers = createAsyncAction(deviceManufacturerConstants.DEVICE_MANUFACTURER_LOADED, () =>
    api.get('deviceManufacturer').then(res => res.data)
);

export const saveDeviceManufacturer = createAsyncAction(deviceManufacturerConstants.DEVICE_MANUFACTURER_CREATED,
    manufacturer =>
        api.post('deviceManufacturer', manufacturer).then(res => res.data)
);

export const updateDeviceManufacturer = createAsyncAction(
    deviceManufacturerConstants.DEVICE_MANUFACTURER_UPDATED,
    (manufacturerId, manufacturer) =>
        api.put(`deviceManufacturer/${manufacturerId}`, manufacturer).then(res => res.data)
);

export const deleteDeviceManufacturer = createAsyncAction(deviceManufacturerConstants.DEVICE_MANUFACTURER_DELETED,
    manufacturer =>
        api.delete(`deviceManufacturer/${manufacturer.id}`).then(() => manufacturer.id)
);
